import { useEffect, useState } from 'react';
import * as queries from '../graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';

function useFetchedNodes() {
  const [error, setError] = useState(null);
  const [fetchedData, setFetchedData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const queryName = 'getNodes';

      try {
        setLoading(true);
        const { data } = await API.graphql(graphqlOperation(queries[queryName]));
        setFetchedData(data[queryName]);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        setError(e);
      }
    }

    fetchData();

  }, []);

  return {
    error,
    fetchedData,
    loading
  };
}

export default useFetchedNodes;